export default __webpack_public_path__ + "static/media/furkanuc4.809e3d8c.jpg";